function getCookie(name) {
  if (typeof document === "undefined") return null;
  const match = document.cookie
    .split("; ")
    .map((v) => v.split("="))
    .find(([k]) => k === name);
  return match ? decodeURIComponent(match[1]) : null;
}

function setCookie(name, value, opts = {}) {
  if (typeof document === "undefined") return;
  const parts = [
    `${name}=${encodeURIComponent(value)}`,
    `Path=${opts.path || "/"}`,
    `Max-Age=${opts.maxAge || 60 * 60 * 24 * 365}`,
  ];
  if (opts.secure) parts.push("Secure");
  if (opts.sameSite) parts.push(`SameSite=${opts.sameSite}`);
  document.cookie = parts.join("; ");
}

function generateId() {
  try {
    if (
      typeof crypto !== "undefined" &&
      typeof crypto.randomUUID === "function"
    ) {
      return crypto.randomUUID();
    }
  } catch (_) {
    /* fall through */
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random()
    .toString(36)
    .slice(2)}`;
}

export function getAppDeviceId(formName) {
  if (typeof document === "undefined") return null;
  let appDeviceId = getCookie(formName);
  if (!appDeviceId) {
    appDeviceId = generateId();
    setCookie(formName, appDeviceId, {
      path: "/",
      maxAge: 60 * 60 * 24 * 365,
      secure: process.env.NODE_ENV === "production",
      sameSite: "Lax",
    });
  }
  return appDeviceId;
}

export function readAppDeviceId(formName) {
  if (typeof document === "undefined") return null;
  return getCookie(formName);
}

export function deleteAppDeviceId(formName) {
  if (typeof document === "undefined") return;
  document.cookie = `${formName}=; Max-Age=0; Path=/`;
}
